import styled from "@emotion/styled";
import colors from "../../styles/colors";
import { css } from "@emotion/react";
export const TabContainer = styled.div ``;
export const Wrapper = styled.div `
  font-family: Inter;
  font-weight: 400;
  background-color: white;
  border: 0;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: row;
  padding: 0 1.5rem;
`;
export const TabContent = styled.div `
  display: flex;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  background: ${colors["color-gray-10"]};
  max-height: 22.25rem;
  overflow: auto;
`;
export const TabFooter = styled.div `
  z-index: 2;
  position: relative;
  display: flex;
  padding: 0.75rem 0 0.75rem 0;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  box-shadow: 0px -2px 4px -2px rgba(0, 0, 0, 0.05),
    0px -4px 6px -1px rgba(0, 0, 0, 0.05);
`;
export const TabList = styled.div `
  display: flex;
  gap: 1rem;

  .tabItems.disabled {
    pointer-events: none; /* Prevent clicks */
    opacity: 0.5;
  }
`;
export const TabItem = styled.div `
  white-space: nowrap;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0 0.125rem 0.625rem;
  gap: 0.625rem;
  color: ${colors["color-gray-120"]};
  :hover {
    color: ${colors["color-black-100"]};
    border-bottom: 0.125rem solid ${colors["color-blue-80"]};
    span {
      font-weight: 400;
    }
  }
  :not(:hover) {
    margin-bottom: 0.125rem;
  }
  :focus {
    color: ${colors["color-black-100"]};
    border-bottom: 0.125rem solid ${colors["color-blue-100"]};
    span {
      font-weight: 400;
    }
  }
  ${(props) => isActive(props.active)}
`;
function isActive(isActive) {
    return isActive
        ? css `
        font-weight: 600;
        color: ${colors["color-blue-160"]};
        border-bottom: 0.125rem solid ${colors["color-blue-100"]};
        :not(:hover) {
          margin-bottom: 0;
        }
        :hover {
          font-weight: 600;
          color: ${colors["color-blue-160"]};
          border-bottom: 0.125rem solid ${colors["color-blue-100"]};
          span {
            font-weight: 600;
          }
        }
        :focus {
          font-weight: 600;
          color: ${colors["color-blue-160"]};
          border-bottom: 0.125rem solid ${colors["color-blue-100"]};
          span {
            font-weight: 600;
          }
        }
      `
        : null;
}
//# sourceMappingURL=Tab.styled.js.map